import React, { useState, useEffect } from 'react';
import VideoOverlay from './components/VideoOverlay';
import "./App.css";
import VirtualizedGrid from './components/VirtualizedGrid';
import LandingPage from './components/landingPage';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ChannelList from './components/ChannelList';
import { AuthProvider } from './context/AuthContext';
import { ChannelDataProvider, useChannelData } from './context/ChannelDataContext';
import Login from './components/Login';
import Signup from './components/Signup';
import AdminRoute from './components/admin/AdminRoute';
import AdminDashboard from './components/admin/AdminDashboard';
import UsersRegistered from './components/admin/UsersRegistered';
import Events from './components/admin/Events';
import AdminChannelSync from './components/admin/AdminChannelSync';
import CustomerEvents from './components/CustomerEvents';
import { LanguageProvider } from './context/LanguageContext';

const RECENT_CHANNELS_STORAGE_KEY = 'asva.recentChannels.v1';
const MAX_RECENT_CHANNELS = 12;

function getChannelIdentity(channel) {
  if (!channel) return '';
  const firstIptv = Array.isArray(channel.iptv_urls) ? channel.iptv_urls[0] : '';
  const firstYoutube = Array.isArray(channel.youtube_urls) ? channel.youtube_urls[0] : '';
  return `${channel.name || ''}|${firstIptv || ''}|${firstYoutube || ''}`;
}

function loadRecentChannels() {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(RECENT_CHANNELS_STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(Boolean);
  } catch {
    return [];
  }
}

function AppRoutes() {
  const { allCountries, memoizedAllChannels } = useChannelData();
  const [highlightedCountry, setHighLightedCountry] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [channels, setChannels] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedChannel, setSelectedChannel] = useState(null);
  const [recentChannels, setRecentChannels] = useState(loadRecentChannels);
  const onSelectChannel = (channel) => {
    setSelectedChannel(channel);
    setRecentChannels((prev) => {
      if (!channel) return prev;
      const current = Array.isArray(prev) ? prev : [];
      const id = getChannelIdentity(channel);
      const deduped = current.filter((item) => getChannelIdentity(item) !== id);
      return [channel, ...deduped].slice(0, MAX_RECENT_CHANNELS);
    });
  };

  const onClose = () => {
    setSelectedCountry(null);
    setSelectedChannel(null);
  };

  useEffect(() => {
    if (!selectedChannel) return;
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [selectedChannel]);

  useEffect(() => {
    if (selectedCountry) {
      const countryCode = selectedCountry.toLowerCase();
      const countryData = allCountries[countryCode];
      setChannels(countryData ? countryData : []);
    }
  }, [selectedCountry, allCountries]);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      window.localStorage.setItem(RECENT_CHANNELS_STORAGE_KEY, JSON.stringify(recentChannels));
    } catch {
      // Ignore storage write errors (private mode, quota, etc.)
    }
  }, [recentChannels]);

  return (
    <Routes>
          <Route path="/" element={<LandingPage setHighLightedCountry={setHighLightedCountry} setChannels={setChannels} setSearchTerm={setSearchTerm} setSelectedCountry={setSelectedCountry} channels={channels} setSelectedChannel={onSelectChannel} recentChannels={recentChannels} />} />
          <Route path="/admin" element={<AdminRoute >
            <AdminDashboard>
             
            </AdminDashboard>
          </AdminRoute>} > 
          <Route index element={<UsersRegistered />} />
              <Route path="users" element={<UsersRegistered />} />
              <Route path="events" element={<Events />} />
          <Route path="channel-sync" element={<AdminChannelSync />} />
          </Route>

          <Route path="/all-countries" element={
            // <PrivateRoute>
            <VirtualizedGrid highlightedCountry={highlightedCountry} setHighLightedCountry={setHighLightedCountry} channels={channels} setSelectedChannel={onSelectChannel} memoizedAllChannels={memoizedAllChannels} setSelectedCountry={setSelectedCountry} searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
            // </PrivateRoute>
          } />
          <Route path='/events' element={
            // <PrivateRoute>
            <CustomerEvents/>
            // </PrivateRoute>
            } />
          <Route path='/player' element={<VideoOverlay setChannel={onSelectChannel} channel={selectedChannel} channels={channels} onClose={onClose} />} />
          <Route path="/channels" element={
            // <PrivateRoute>
              <ChannelList channels={channels} setSelectedChannel={onSelectChannel} setSelectedCountry={setSelectedCountry} selectedCountry={selectedCountry} searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
            // </PrivateRoute>
          } />
          {/* login  */}
          <Route path='/login' element={<Login />} />
          <Route path='/signup' element={<Signup />} />
          <Route path="*" element={<LandingPage setSelectedCountry={setSelectedCountry} channels={channels} setSelectedChannel={onSelectChannel} recentChannels={recentChannels} />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-slate-950 text-slate-100">
        <LanguageProvider>
          <AuthProvider>
            <ChannelDataProvider>
              <AppRoutes />
            </ChannelDataProvider>
          </AuthProvider>
        </LanguageProvider>
      </div>
    </BrowserRouter>
  );
}

export default App;
